/**
 * 主題功能配置
 * 每個主題都明確配置自己的功能
 * 不依賴預設值
 */

const themeFeatures = {
  theme_gold: {
    showChatBox: true,
    showSupportCenter: true,
    showMemberTerms: true,
    showBlog: true,
    showAffiliates: true,
    showEvent: true,
    showBankCreate: true,
    showUserLetter: true,
    showNews: true,
    showSupMenu: true,
    showFooterText: true,
    showFollowUs: true,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: true,
    showFooterIntro: true,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: true,
    showWithdrawalDesc: true,
    showVipContent: true,
    showKYC: true,
    showKYCTips: true,
    showPayTypeList: true,
    showPersonalAd: true
  },
  theme_blue: {
    showChatBox: true,
    showSupportCenter: false,
    showMemberTerms: false,
    showBlog: false,
    showAffiliates: true,
    showEvent: false,
    showBankCreate: true,
    showUserLetter: true,
    showNews: true,
    showSupMenu: true,
    showFooterText: false,
    showFollowUs: false,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showKYC: true,
    showKYCTips: true,
    showPayTypeList: false,
    showPersonalAd: false
  },
  theme_purple: {
    showChatBox: true,
    showSupportCenter: false,
    showMemberTerms: true,
    showBlog: false,
    showAffiliates: false,
    showEvent: false,
    showBankCreate: false,
    showUserLetter: false,
    showNews: false,
    showSupMenu: false,
    showFooterText: false,
    showFollowUs: false,
    showFooterBank: false,
    showFooterProviders: false,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: false,
    showFooterHelpCenter: false,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: false,
    showKYC: false,
    showKYCTips: false,
    showPayTypeList: true,
    showPersonalAd: true
  },
  theme_cb168: {
    showChatBox: false,
    showSupportCenter: false,
    showMemberTerms: false,
    showBlog: false,
    showAffiliates: false,
    showEvent: false,
    showBankCreate: true,
    showUserLetter: true,
    showNews: true,
    showSupMenu: true,
    showFooterText: true,
    showFollowUs: true,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: true,
    showFooterIntro: true,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showKYC: true,
    showKYCTips: true,
    showPayTypeList: true,
    showPersonalAd: false
  },
  theme_tiger: {
    showChatBox: true,
    showSupportCenter: false,
    showMemberTerms: true,
    showBlog: false,
    showAffiliates: false,
    showEvent: true,
    showBankCreate: true,
    showUserLetter: true,
    showNews: true,
    showSupMenu: true,
    showFooterText: true,
    showFollowUs: false,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showKYC: true,
    showKYCTips: false,
    showPayTypeList: false,
    showPersonalAd: false
  },
  theme_neotri: {
    showChatBox: true,
    showSupportCenter: false,
    showMemberTerms: false,
    showBlog: false,
    showAffiliates: false,
    showEvent: false,
    showBankCreate: true,
    showUserLetter: true,
    showNews: true,
    showSupMenu: true,
    showFooterText: false,
    showFollowUs: false,
    showFooterBank: true,
    showFooterProviders: true,
    showFooterLicense: false,
    showFooterIntro: false,
    showFooterResponsible: true,
    showFooterHelpCenter: true,
    showDepositGuide: false,
    showWithdrawalDesc: false,
    showVipContent: true,
    showKYC: true,
    showKYCTips: false,
    showPayTypeList: false,
    showPersonalAd: false
  }
}

/**
 * ServiceChat 客服設定
 * 只列出使用 ServiceChat 的主題；未列出的主題維持原本的 LiveChat。
 */
const SERVICE_CHAT_LOADER_SRC = 'https://servicechat.ewin888.com/widget/servicechat-widget-loader.js'
const serviceChatTenantKeys = {
  theme_gold: 'scwk_BH6zk9mbCXvVFytIOlMZkPvbWUvQqTrIipQstjRFfts',
  theme_tiger: 'scwk_kfzqxWrdCp3pB0RiTUpIjsclWxYo11iqvxzC_0Wx7R0'
}

/**
 * 取得當前主題的 ServiceChat 設定
 * @returns {{loaderSrc: string, tenantKey: string}|null} 沒有設定則回傳 null（表示用 LiveChat）
 */
export function getServiceChatConfig() {
  const tenantKey = serviceChatTenantKeys[getCurrentTheme()]
  if (!tenantKey) return null
  return { loaderSrc: SERVICE_CHAT_LOADER_SRC, tenantKey }
}

/**
 * 獲取當前主題的完整配置
 */
export function getCurrentThemeConfig() {
  const currentTheme = process.env.VUE_APP_THEME || 'theme_gold'
  const config = themeFeatures[currentTheme]

  if (!config) {
    console.error(`未找到主題配置: ${currentTheme}`)
    return {}
  }

  return config
}

/**
 * 檢查當前主題是否啟用某功能
 */
export function hasFeature(featureName) {
  const config = getCurrentThemeConfig()
  return config[featureName] ?? false
}

/**
 * 獲取當前主題名稱
 */
export function getCurrentTheme() {
  return process.env.VUE_APP_THEME || 'theme_gold'
}

export default {
  getCurrentThemeConfig,
  hasFeature,
  getCurrentTheme,
  getServiceChatConfig
}
